export default __webpack_public_path__ + "static/media/planting.35f06ceb.png";